import React from "react";

import { ProductFeatureModel } from "@api/mappers/products.mapper";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { renderFeature } from "@components/Product/ProductTile/components/description/description.component";

import "./keyFeatures.scss";

export type KeyFeaturesProps = {
    features: Array<ProductFeatureModel>;
};

const KeyFeatures = ({ features }: KeyFeaturesProps) => {
    const { t } = useGranite();

    const title = t("keyfeatures.title");

    return (
        <>
            {!!title && <p className={"heading-5"}>{title}</p>}
            <ul
                className="key-features-component__list"
                data-test="keyFeatures-list"
            >
                {features
                    .filter(f => !!f.coreFeature)
                    .slice(0, 4)
                    .map(keyFeature => (
                        <li
                            className="key-features-component__item"
                            data-test={`keyFeatures-list-item-${keyFeature.name}`}
                            key={`keyFeatures-list-item-${keyFeature.name}`}
                        >
                            <span
                                className="key-features-component__name"
                                data-test={`keyFeatures-list-item-${keyFeature.name}-name`}
                            >
                                {keyFeature.name}
                            </span>
                            <span
                                className="key-features-component__value"
                                data-test={`keyFeatures-list-item-${keyFeature.name}-value`}
                            >
                                {renderFeature(keyFeature)}
                            </span>
                        </li>
                    ))}
            </ul>
            <a
                href="#specs"
                className="btn-link d-none d-lg-inline-block"
                data-test="keyFeatures-link"
            >
                {t("productDetail.link.showMoreFeatures")}{" "}
                <i className="las la-angle-right la-lg"></i>
            </a>
        </>
    );
};

export { KeyFeatures };
